define.alias("ember-math-helpers/helpers/sign", "calendar/helpers/sign");